export class Config {
	/* public clientID = '';
    public environment = 'prod'; // allowed values are dev and prod
    public logLevel = 0;
    public displayLog = false;
    public courseTitle = 'NAVEX Training';
    public opProfile = 'demo';
    public trackMode = 'disabled';
    public useProxy = true;
    public proxyUrl = 'http://cdn2.navexglobal.com/proxy/aiccproxy.php';
    public AUNum = 'single';
    public completedVal = 'p';
    public newlnChar = '\n';
    public quietComplete = true;
    public scoreMode = 1;
    public bkMkFreq =  3;
    public saveInt = 5;
    public maxCommRetry = 3;
    public commDelay = 3;
    public escapeCount = 1;
    public aiccModDomain = '';
    public aiccModScheme = 'http';
    public aiccModPort = '';
    public timeSaveMode = 1;
    public timeSingleSend = false;
    public bufferPages = true;
    public alwaysCheckError = true;
    public scormExitToEmpty = false;*/

	private _configData = {};

	public setData(data) {
		this._configData = data;
	}

	public toObject(data) {
		return Object.assign({}, data);
		/*let cbtdata = [];
        for(let props in data){
            cbtdata[props]= data[props];
        }
        return cbtdata;*/
	}

	public get configData() {
		return this._configData;
	}
}
